export default __webpack_public_path__ + "static/media/view.eb9d8311.png";